import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpoint.bulkImport.cancelImportMessage': {
    defaultMessage: 'Import cancelled - Some checkpoints may have been created.',
    id: 'checkpoint.bulkImport.cancelImportMessage'
  },
  'checkpoint.bulkImport.error.invalidFile': {
    defaultMessage: 'Invalid CSV File',
    id: 'checkpoint.bulkImport.error.invalidFile'
  },
  'checkpoint.bulkImport.error.maxlength': {
    defaultMessage: 'CSV must be under {MAX_CSV_LENGTH} lines',
    id: 'checkpoint.bulkImport.error.maxlength'
  },
  'checkpoint.bulkImport.error.nofields': {
    defaultMessage: 'All rows must contain {LENGTH} elements',
    id: 'checkpoint.bulkImport.error.nofields'
  },
  'checkpoint.bulkImport.error.uniqid': {
    defaultMessage: 'All identifiers must be unique',
    id: 'checkpoint.bulkImport.error.uniqid'
  },
  'checkpoint.bulkImport.error.uniqname': {
    defaultMessage: 'All names must be unique',
    id: 'checkpoint.bulkImport.error.uniqname'
  },
  'checkpoint.bulkImport.error.validation': {
    defaultMessage: 'Error in checkpoint {index}: {error}',
    id: 'checkpoint.bulkImport.error.validation'
  },
  'checkpoint.bulkImport.formHeader.cancel': {
    defaultMessage: 'Cancel',
    id: 'checkpoint.bulkImport.formHeader.cancel'
  },
  'checkpoint.bulkImport.formHeader.confirm': {
    defaultMessage: 'Confirm',
    id: 'checkpoint.bulkImport.formHeader.confirm'
  },
  'checkpoint.bulkImport.formHeader.csv': {
    defaultMessage: 'CSV',
    id: 'checkpoint.bulkImport.formHeader.csv'
  },
  'checkpoint.bulkImport.formHeader.import': {
    defaultMessage: 'Import',
    id: 'checkpoint.bulkImport.formHeader.import'
  },
  'checkpoint.bulkImport.formHeader.location': {
    defaultMessage: 'Location',
    id: 'checkpoint.bulkImport.formHeader.location'
  },
  'checkpoint.bulkImport.formHeader.selectFile': {
    defaultMessage: 'Select File',
    id: 'checkpoint.bulkImport.formHeader.selectFile'
  },
  'checkpoint.bulkImport.formHeader.type': {
    defaultMessage: 'Type',
    id: 'checkpoint.bulkImport.formHeader.type'
  },
  'checkpoint.bulkImport.found': {
    defaultMessage: 'Found {count} checkpoints',
    id: 'checkpoint.bulkImport.found'
  },
  'checkpoint.bulkImport.helperText.1': {
    defaultMessage: 'Be formatted <code>name,description,proof-of-presence-identity</code>',
    id: 'checkpoint.bulkImport.helperText.1'
  },
  'checkpoint.bulkImport.helperText.2': {
    defaultMessage: 'Not contain a header row',
    id: 'checkpoint.bulkImport.helperText.2'
  },
  'checkpoint.bulkImport.helperText.3': {
    defaultMessage: 'Not contain more than 100 checkpoints',
    id: 'checkpoint.bulkImport.helperText.3'
  },
  'checkpoint.bulkImport.helperText.header': {
    defaultMessage: 'The CSV file must:',
    id: 'checkpoint.bulkImport.helperText.header'
  },
  'checkpoint.bulkImport.progress.subtitle': {
    defaultMessage: 'Checkpoints Importing - Please do not close this page',
    id: 'checkpoint.bulkImport.progress.subtitle'
  },
  'checkpoint.bulkImport.progress.title': {
    defaultMessage: 'Import Progress',
    id: 'checkpoint.bulkImport.progress.title'
  },
  'checkpoint.bulkImport.title': {
    defaultMessage: 'Bulk Import',
    id: 'checkpoint.bulkImport.title'
  }
});
